import { isWindows } from 'react-device-detect'

export const commandKeyPressed = (
  event: KeyboardEvent | MouseEvent | React.KeyboardEvent | React.MouseEvent
) => {
  if (isWindows) return event.ctrlKey || event.metaKey
  return event.metaKey
}
